module.exports = __webpack_public_path__ + "static/media/icon-pdf.d9139830.svg";